/** Border state for contact fields that show verification feedback. */

export const ContactVerifyStatus = {
  Verified: "verified",
  Unverified: "unverified",
} as const;

export type ContactVerifyStatus =
  (typeof ContactVerifyStatus)[keyof typeof ContactVerifyStatus];

const VERIFY_STATUS_BORDER_CLASS: Record<ContactVerifyStatus, string> = {
  [ContactVerifyStatus.Verified]:
    "border-success-500 focus-visible:border-success-500 focus-visible:ring-success-500/20",
  [ContactVerifyStatus.Unverified]:
    "border-warning-500 focus-visible:border-warning-500 focus-visible:ring-warning-500/20",
};

/** Verification border for a contact control; a validation error takes precedence. */
export function verifyStatusBorderClass(
  status: ContactVerifyStatus | undefined,
  hasError: boolean,
): string | undefined {
  return status && !hasError ? VERIFY_STATUS_BORDER_CLASS[status] : undefined;
}
